import { useEffect, useState } from 'react';

function getRandomIndex(maxLength: number) {
  return Math.floor(Math.random() * maxLength);
}

const useTypewriter = (inputs: string[], speed = 100) => {
  const [displayText, setDisplayText] = useState('');
  const [currentWord, setCurrentWord] = useState(inputs[getRandomIndex(inputs.length)]);

  useEffect(() => {
    let i = 0;
    const typingInterval = setInterval(() => {
      if (i < currentWord.length + 20) {
        setDisplayText(prevText => prevText + currentWord.charAt(i));
        i = i + 1;
      } else {
        i = 0;
        setCurrentWord(
          inputs[(inputs.findIndex(input => input === currentWord) + 1) % inputs.length],
        );
        setDisplayText('');
      }
    }, speed);

    return () => {
      clearInterval(typingInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWord, speed]);

  return displayText;
};

export default useTypewriter;
